export default "__VITE_ASSET__XohSFikJ__"